<template>
  <div class="item-overview-w">
    <div class="group-w">
      <div class="group">
        <item-card :items="itemsDetail" @subtotal-change="updateSubtotal"  v-on:to-item="toItem"></item-card>
      </div>
    </div>
  </div>
</template>

<script>
import ItemCard from './ItemCard.vue'

export default {
  components: {
    ItemCard
  },
  props: {
    items: Array,
    folderNames: Object
  },
  data () {
    return {
      subtotal: 0
    }
  },
  computed: {
    itemsDetail: function () {
      let items = []
      for (let item of this.items) {
        item.folderName = item.folderId ? this.folderNames[item.folderId] : 'No Folder'
        items.push(item)
      }
      return items
    }
  },
  methods: {
    toItem: function (item) {
      this.$emit('to-item', item)
    },
    updateSubtotal: function (subtotal) {
      this.subtotal = subtotal
    }
  }
}
</script>

<style>
.sum-price {
  color: rgba(0, 0, 0, 0.95);
  font-size: 18px;
  line-height: 27px;
  font-weight: bold;
  text-align: right;
  margin-top: 32px;
}

.item-overview-w {
  margin-bottom: 32px;
}

.project-buttons {
  text-align: right;
  /* margin-top: 24px; */
}

.project-button {
  font-size: 24px;
  margin-right: 24px;
  cursor: pointer;
  cursor: pointer;
}

.group-w {
  width: 76vw;
  margin: 0 12vw 0 12vw;
  box-sizing: border-box;
  padding-bottom: 24px;
}

.group {
  background-color: #ffffff;
  overflow: hidden;
  border-radius: 20px;
  box-sizing: border-box;
  padding: 20px;
  border: solid 1px #f0f0f0;
}

.group-title {
  color: #515151;
  font-size: 18px;
  font-weight: bold;
  line-height: 27px;
  box-sizing: border-box;
  padding: 0 12px 6px 12px;
  border-bottom: solid 1px #f0f0f0;
  font-weight: 700;
}

@media screen and (max-width: 991px) {
  .group-w {
    width: calc(100vw - 32px);
    margin: 0 16px 0 16px;
    box-sizing: border-box;
    padding-bottom: 16px;
  }
}
</style>
